import classnames from 'classnames';
import React, { PureComponent } from 'react';

import CloseButton from './CloseButton';
import Overlay from './Overlay';

const CSS = require('./Modal.less');

interface ModalProps {
  show: boolean;
  onClose: () => void;
  className?: string;
  overlayClassName?: string;
  children: any;
  portalId?: string;
  fullscreen?: boolean;
  hideClose?: boolean;
}

class Modal extends PureComponent<ModalProps> {
  container = null;

  closeModal = () => {
    if (!!this.props.onClose && this.props.show) {
      this.props.onClose();
    }
  };

  modalClick = (event) => {
    event.nativeEvent.stopImmediatePropagation();
    event.stopPropagation();

    if (!this.container.contains(event.target)) {
      this.closeModal();
    }
  };

  setContainer = (c) => {
    this.container = c;
  };

  render() {
    if (!this.props.show) {
      return null;
    }

    return (
      <Overlay
        onEsc={this.closeModal}
        className={classnames(this.props.overlayClassName, {
          [CSS.RemoveOverlayBackground]: this.props.fullscreen,
        })}
        onClick={this.modalClick}
        portalId={this.props.portalId || 'dialogPortal'}
      >
        <dialog
          ref={this.setContainer}
          className={classnames(CSS.Modal, {
            [this.props.className]: this.props.className,
            [CSS.ModalFullscreen]: this.props.fullscreen,
          })}
        >
          {!this.props.hideClose && <CloseButton onClick={this.closeModal} />}
          {this.props.children}
        </dialog>
      </Overlay>
    );
  }
}

export default Modal;
